import { DomainLocation } from "../models/domain-location.model";

export const getHost = (): string => {
  if (process.server) {
    const { req } = useRequestEvent().node;

    // Virtuozee
    return ("https://" + req.headers.host) as string;
  } else {
    return window.location.protocol + "//" + window.location.host;
  }
};

export const domains: Record<string, DomainLocation> = {
  "good-balance.eu": {
    title: "pl",
    defaultLocalization: "pl",
  },
  "good-balance.com.ua": {
    title: "ua",
    defaultLocalization: "uk",
  },
};

export const useLocation = (): DomainLocation => {
  const url = new URL(getHost());
  const host = url.hostname;

  return domains[host as keyof typeof domains] ?? domains["good-balance.eu"];
};
